import { useAtomValue } from 'jotai';
import { useLocation } from 'react-router-dom';
import { unwrappedNavigationPlayerIdAtom, unwrappedNavigationTeamIdAtom } from '@/atoms/navigation';
import { SwitchToClassicButton } from './SwitchToClassicButton';

export const SwitchToClassicEntityButton = () => {
  const { pathname } = useLocation();
  const entity = pathname.split('/')[2];
  const navigationAtom = entity === 'player' ? unwrappedNavigationPlayerIdAtom : unwrappedNavigationTeamIdAtom;
  const entityIqId = useAtomValue(navigationAtom)?.iqId;

  if (!entityIqId) return null;

  const classicIqPath = `${entity}/${entityIqId}/dashboard`;

  return (
    <SwitchToClassicButton
      path={classicIqPath}
      navOverrides={{
        [entity]: true,
      }}
    />
  );
};
